<div class="flex justify-center w-full m-1">
  <!--
    The card being filled in, mirrored back to the user. A grid rather than flow: the design puts
    the chip, then the number, then the holder and expiry side by side, and the expiry keeps its
    own column so it stays put however long the holder's name is.
  -->
  <div class="w-full max-w-sm grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-4 p-3 rounded bg-primary text-white">
    <mat-icon svgIcon="ph-regular-circuitry" class="col-start-1 row-start-1 !w-8 !h-8 shrink-0"></mat-icon>

    <div class="col-start-1 row-start-2 flex flex-col gap-1 min-w-0">
      <span class="text-body-md">{{ 'components.fancy_card.card_number' | translate }}</span>
      <span class="text-title-sm truncate">{{ cardNumber }}</span>
    </div>

    <div *ngIf="showHolderName" class="col-start-1 row-start-3 flex flex-col gap-1 min-w-0">
      <span class="text-body-md">{{ 'components.fancy_card.holder' | translate }}</span>
      <span class="text-title-sm truncate">{{ displayHolderName }}</span>
    </div>

    <div class="col-start-2 row-start-3 flex flex-col gap-1 self-start">
      <span class="text-body-md whitespace-nowrap">{{ 'components.fancy_card.valid_until' | translate }}</span>
      <span class="text-title-sm whitespace-nowrap">{{ expiration }}</span>
    </div>
  </div>
</div>
